import { IFrameConfig } from './iframe/iFrameConfig';
import { CategoryPageConfig } from './category-page/CategoryPageConfig';

export const MiscConfigs = [
    IFrameConfig,
    CategoryPageConfig,
];
